import script from "./CavaloSaltador.vue?vue&type=script&setup=true&lang=js"
export * from "./CavaloSaltador.vue?vue&type=script&setup=true&lang=js"

import "./CavaloSaltador.vue?vue&type=style&index=0&id=7026485e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7026485e"]])

export default __exports__